import * as React from 'react'
import * as Redux from 'react-redux'
import styled from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'
import { t } from '@owl-nest/localize'
import * as model from '@owl-nest/models'

import * as URLs from '../../../../utils/URLs'
import * as projectModel from '../../../../models/project'
import { RootState } from '../../../../../reducers'
import * as UFE from '../../../../../UFE'

const News = styled.div`
  border: 1px solid ${plume.COLORS.PRIMARY_SAND};
  height: auto;
  justify-content: baseline;
  text-align: center;
  padding: 21px 18px;
  background-color: ${plume.COLORS.PRIMARY_WHITE};
  transition: 0.3s ease;
  margin-bottom: 45px;

  &:hover {
    box-shadow: ${plume.EFFECTS.SHADOW_2};
  }
`

const TitleBlock = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
`
const Icon = styled.a`
  display: inline-flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  margin-right: 8px;
  margin-top: 5px;
  height: 33px;
  width: 33px;
  border-radius: 50%;
  background-color: ${plume.COLORS.BLUE_SHADE_1};

  svg {
    max-width: 19px;
    max-height: 19px;
    fill: ${plume.COLORS.PRIMARY_BLUE};
  }
`

const LinkToNewsCreation = styled(plume.styles.heading.L)`
  text-decoration: none;
`

export function AddNews(): React.ReactElement<unknown> {
  const project = Redux.useSelector<RootState, projectModel.Project>((state) => state.application.project.data)
  const newsHelper = model.i18n.get(UFE.LINKS.newsHelper)

  return (
    <News>
      <TitleBlock>
        <Icon href={URLs.getAddNewsURL(project)}>
          <plume.glyphs.stroke.Plus />
        </Icon>
        <LinkToNewsCreation as="a" href={URLs.getAddNewsURL(project)}>
          {t('Add a post')}
        </LinkToNewsCreation>
      </TitleBlock>
      <plume.styles.copy.S>
        <plume.Link target="_blank" rel="nooponer noreferrer" href={newsHelper} tinted>
          {t('10 tips for successful posts')}
        </plume.Link>
      </plume.styles.copy.S>
    </News>
  )
}
